export const eventNames = {
  // These mappings are for 2020
  'Copenhagen (wine only) 2022': 'Oregon',
  'Copenhagen, May - OWN TABLES': 'California',
  'Trade Tasting & Masterclass : Copenhagen, Denmark - May 11, 2022':
    'Washington',
};
